/**
 * api接口统一管理
 */
import { get, post } from "./axios";


// 热门版块
export const getSectionHeat = (params) => get(`/open/section-app/sectionHeat/${params.number}`, params);

// 帖子瀑布流加载，按条件查询并跳过指定行数
export const getForumList = (params) => get(`/note/pull/${params.skip}/${params.limit}`, params);

// 帖子点赞&取消点赞
export const setGiveALike = (params) => post(`/note-like-app/toggle/${params.noteId}`, params);

// 帖子收藏&取消收藏
export const setCollection = (params) => post(`/note-collect-app/toggle/${params.noteId}`, params);

// 帖子分享
export const shareForumPost = (params) => post(`/open/note-share-app/toggle/${params.noteId}`, params);

// 按 id 查询帖子
export const getForumDetails = (params) => get(`/note-app/${params.id}`, params);

// 分页查询帖子评论
export const getForumComment = (params) => get(`/note-comment-app/page/${params.number}/${params.limit}`, params);

// 新增帖子评论
export const addForumComment = (params) => post(`/note-comment-app`, params);

// 分页查询我的收藏(帖子)
export const getCollectForum = (params) => get(`/note-collect-app/page/${params.number}/${params.limit}`, params);

// 分页查询帖子记录
export const getHistoryForum = (params) => get(`/note-history/page/${params.number}/${params.limit}`, params);

// 分页查询帖子点赞
export const getGiveALikeList = (params) => get(`/note-like-app/page/${params.number}/${params.limit}`, params);

// 分页查询帖子分享
export const getShareForumPostList = (params) => get(`/open/note-share-app/page/${params.number}/${params.limit}`, params);

// 上传到论坛目录，单个上传：论坛图片
export const uploadFileCommunity = (params) => post(`/upload/uploadFileCommunity`, params);

// 新增帖子
export const addForum = (params) => post(`/note`, params);

// 分页查询热门版块
export const getSectionHeatList = (params) => get(`/open/section-app/page/${params.number}/${params.limit}`, params);


// WEBPACK FOOTER //
// ./src/api/forum.js